import { CookieOptions, SameSite } from 'ngx-cookie-service';

export const cookieOptions: CookieOptions = {
  expires: 3600,
  secure: true,
  sameSite: 'Strict' as SameSite,
  path: '/'
};
